import {ClockSvg} from "./ClockSvg";
import {LogOutSvg} from "./LogOutSvg";
import {CheckListSvg} from "./CheckListSvg";

export const SvgIcons = Object.assign({}, {
    ClockSvg, LogOutSvg, CheckListSvg
})
